var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.7 368.7",
    style: {
      enableBackground: "new 0 0 368.7 368.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#377DFF;stroke-miterlimit:10;}\n\t.st1{fill:#377DFF;}\n\t.st2{fill:none;stroke:#377DFF;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:15.1428,15.1428;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,159.1c0-0.3,0-0.5,0-0.7l14.4-2.5l-4.4-25l-14.4,2.5c-3.2-9.1-8-17.3-14.2-24.5l9.4-11.2l-19.4-16.3 l-9.4,11.2c-8-4.8-17-8.1-26.6-9.7l0-14.6l-25.3,0l0,14.6c-9.6,1.6-18.6,4.9-26.6,9.7L110,81.4L90.6,97.7l9.4,11.2 c-6.1,7.2-11,15.4-14.2,24.5l-14.4-2.5l-4.4,25l14.4,2.5c0,0.3,0,0.5,0,0.7c0,9.5,1.7,18.7,4.9,27.1l-12.7,7.3l12.7,21.9 l12.7-7.3c6,7.3,13.4,13.5,21.7,18.2l-5,13.7l23.8,8.7l5-13.7c4.6,0.8,9.3,1.3,14.2,1.3c4.8,0,9.6-0.4,14.2-1.3l5,13.7l23.8-8.7 l-5-13.7c8.3-4.7,15.7-10.9,21.7-18.2l12.7,7.3l12.7-21.9l-12.7-7.3C234.1,177.8,235.9,168.7,235.9,159.1z M158.6,216.4 c-31.6,0-57.2-25.6-57.2-57.2c0-31.6,25.6-57.2,57.2-57.2c31.6,0,57.2,25.6,57.2,57.2C215.9,190.7,190.3,216.4,158.6,216.4z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 159.2 159.2",
    to: "-360 159.2 159.2",
    dur: "30s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.7,211.9c0-0.3,0-0.5,0-0.7l14.4-2.5l-4.4-25l-14.4,2.5c-3.2-9.1-8-17.3-14.2-24.5l9.4-11.2l-19.4-16.3 l-9.4,11.2c-8-4.8-17-8.1-26.6-9.7l0-14.6l-25.3,0l0,14.6c-9.6,1.6-18.6,4.9-26.6,9.7l-9.4-11.2l-19.4,16.3l9.4,11.2 c-6.1,7.2-11,15.4-14.2,24.5l-14.4-2.5l-4.4,25l14.4,2.5c0,0.3,0,0.5,0,0.7c0,9.5,1.7,18.7,4.9,27.1l-12.7,7.3l12.7,21.9 l12.7-7.3c6,7.3,13.4,13.5,21.7,18.2l-5,13.7l23.8,8.7l5-13.7c4.6,0.8,9.3,1.3,14.2,1.3s9.6-0.4,14.2-1.3l5,13.7l23.8-8.7 l-5-13.7c8.3-4.7,15.7-10.9,21.7-18.2l12.7,7.3l12.7-21.9l-12.7-7.3C286.9,230.6,288.7,221.5,288.7,211.9z M211.4,269.1 c-31.6,0-57.2-25.6-57.2-57.2c0-31.6,25.6-57.2,57.2-57.2c31.6,0,57.2,25.6,57.2,57.2S243,269.1,211.4,269.1z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 211.45 208.13",
    to: "360 211.45 208.13",
    dur: "30s",
    repeatCount: "indefinite"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoError404);
export default __webpack_public_path__ + "static/media/picto-error-404.6fdfa02ad8d43f100619efd447cb56c2.svg";
export { ForwardRef as ReactComponent };